import goldenMedal from "../../../../img/first.png?width=44px";
import silverMedal from "../../../../img/second.png?width=44px";
import bronzenMedal from "../../../../img/third.png?width=44px";
import I18n from "../../../i18n";
import { IRecordItem } from "../../../interfaces/quiz";

function rankingInfoGenerate(rankingItem:IRecordItem):string{
    return`
        <span class="ranking-name">${rankingItem.user}</span>
        <span class="ranking-date">${new Date(rankingItem.date).toLocaleString()}</span>
        <span class="ranking-score">
            <span class="score-label">${I18n.apply("pontos")}</span>
            ${rankingItem.score}
        </span>
    `;
}

function medalGenrator(index:number):string{
    if(index==0)return`<img src="${goldenMedal}" alt="medal">`;
    if(index==1)return`<img src="${silverMedal}" alt="medal">`;
    if(index==2)return`<img src="${bronzenMedal}" alt="medal">`;
    return`<span class="ranking-number">${index+1}</span>`;
}

function genrateRankingItem(index:number,rankingItem:IRecordItem):string{
    return`
        <div class="ranking-item">
            ${medalGenrator(index)}
            ${rankingInfoGenerate(rankingItem)}
        </div>
    `;
}

function renderButtonActive(buttonActive:string):string{
    if(buttonActive=="classic"){
        return `
            <button class="btn-switch active" data-ranking="classic" type="button">
                ${I18n.apply("Clássico")}
            </button>
            <button class="btn-switch" data-ranking="15sec" type="button">
                15.sec
            </button>
        `;
    }else if(buttonActive=="15sec"){
        return `
            <button class="btn-switch" data-ranking="classic" type="button">
                ${I18n.apply("Clássico")}
            </button>
            <button class="btn-switch active" data-ranking="15sec" type="button">
                15.sec
            </button>
        `;
    }
}

export default function ranking(rankingCollection:IRecordItem[],buttonActive:string):string{
    let rowsGenerated:string= "";
    rankingCollection.forEach((rankingItem,index)=>{
        rowsGenerated += genrateRankingItem(index,rankingItem);
    });
    return `
        <div id="ranking-container">
            <h3 class="main-title">Ranking</h3>
            <div class="options-container">
                ${renderButtonActive(buttonActive)}
            </div>
            <div class="list-ranking">
                ${rowsGenerated||I18n.apply("sem registros")}
            </div>
            <button type="button" class="btn-back">${I18n.apply("sair")}</button>
        </div>
    `;
}